<template>
<div>
   <component ref="layout" :is="uiconfig.layoutType" :config="uiconfig" :dictData="globalConfig.dictData" :moduleMethod="globalConfig.userModuleMethod"  @doAction="doAction"  :defaultExport="defaultExport"/>
   <BillExcelImport ref="billImport" :config="billImportConfig" />
   <BirtReportBox ref="report"/>
</div>
</template>

<script>
import Base from '@/components/layouttemplate/base.vue';
export default {
    name:'layoutTemplate',
    extends: Base,
    data () {
        return {
            defaultExport:true
        };
    },
    created() {
        this.init();
        if (this.customInit) {
            this.customInit();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/layouttemplate.vue